const WATERMARK_TEXT = 'MUI X: Missing license key';

function isMissingLicenseWatermark(el: HTMLElement) {
  const text = (el.textContent || '').trim();
  if (text !== WATERMARK_TEXT) return false;

  // The watermark is typically an absolutely-positioned overlay with pointer-events disabled.
  // Keep the check permissive but specific to reduce the chance of hiding unrelated nodes.
  const hasAbsolutePosition = el.style.position === 'absolute' || getComputedStyle(el).position === 'absolute';
  const hasPointerEventsNone = el.style.pointerEvents === 'none' || getComputedStyle(el).pointerEvents === 'none';

  return hasAbsolutePosition && hasPointerEventsNone;
}

function hideAllExistingWatermarks() {
  const divs = document.querySelectorAll<HTMLElement>('div');
  divs.forEach((div) => {
    if (!isMissingLicenseWatermark(div)) return;
    div.style.display = 'none';
    div.setAttribute('data-mui-x-license-watermark-hidden', 'true');
  });
}

/**
 * Installs a MutationObserver that hides the MUI X "Missing license key" watermark whenever it appears.
 * Returns a cleanup function.
 */
export function installMuiXMissingLicenseWatermarkHider() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};

  hideAllExistingWatermarks();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // Check the node itself
        if (isMissingLicenseWatermark(node)) {
          node.style.display = 'none';
          node.setAttribute('data-mui-x-license-watermark-hidden', 'true');
          return;
        }

        // And any descendants (watermark is usually a <div>)
        const descendants = node.querySelectorAll?.<HTMLElement>('div') || [];
        descendants.forEach((div) => {
          if (!isMissingLicenseWatermark(div)) return;
          div.style.display = 'none';
          div.setAttribute('data-mui-x-license-watermark-hidden', 'true');
        });
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}
